export function getThumbUrl(url) {
  if (!url) {
    return null;
  } else if (url.search(/(googleusercontent|\.(svg|webp))/) > 0) {
    return url;
  } else {
    return url.replace("/avatar/original/", "/avatar/thumb/").toLowerCase().replace(".png", ".jpg");
  }
}
